import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Range } from 'slate';
import BlockTypes from '../../types/BlockTypes';
import EntityTypes from '../../types/EntityTypes';
import { normalizeNode, shouldHaveText } from '../utils/NormalizationHelper';
import renderInlines from '../utils/renderInlines';
import insertEntity from '../utils/insertEntity';
import generateBlockId from '../utils/generateBlockId';
import { LINE_BREAK_CHARACTER } from '../constants';
var LINE_BREAKABLE_BLOCKS = [BlockTypes.TABLE_CELL, BlockTypes.UL_LI, BlockTypes.OL_LI, BlockTypes.TODO];
var schema = {
  inlines: _defineProperty({}, EntityTypes.LINE_BREAK, {
    isVoid: true
  })
};
export default (function () {
  return [normalizeNode(EntityTypes.LINE_BREAK, [shouldHaveText, function normalizeNode(node, editor) {
    var parent = editor.value.document.getParent(node.key);

    if (!LINE_BREAKABLE_BLOCKS.includes(parent.type)) {
      var textToBreak = editor.value.document.getPreviousText(node.key); // If the parent node only contains a line_break textToBreak will be null

      if (textToBreak) {
        var range = Range.create().moveToEndOfNode(textToBreak).normalize(editor.value.document);
        editor.splitBlockAtRange(range);
      }

      editor.removeNodeByKey(node.key);
    }
  }]), {
    schema: schema,
    commands: {
      insertLineBreak: function insertLineBreak(editor) {
        return insertEntity(editor, null, LINE_BREAK_CHARACTER, EntityTypes.LINE_BREAK);
      }
    },
    queries: {
      canInsertLineBreak: function canInsertLineBreak(editor) {
        return LINE_BREAKABLE_BLOCKS.includes(editor.value.startBlock.type) && LINE_BREAKABLE_BLOCKS.includes(editor.value.endBlock.type);
      }
    },
    serializers: {
      html: _defineProperty({}, EntityTypes.LINE_BREAK, function (_ref) {
        var attributes = _ref.attributes;
        return React.createElement("br", attributes);
      }),
      markdown: _defineProperty({}, EntityTypes.LINE_BREAK, function (_ref2) {
        var node = _ref2.node;
        return "  \n";
      })
    },
    deserializers: _defineProperty({}, EntityTypes.LINE_BREAK, function () {
      return {
        object: 'inline',
        type: EntityTypes.LINE_BREAK,
        data: {
          entityId: generateBlockId()
        },
        nodes: [{
          object: 'text',
          text: LINE_BREAK_CHARACTER
        }]
      };
    }),
    onKeyDown: function onKeyDown(event, editor, next) {
      if (editor.value.selection.isUnset) return next();

      if (event.key === 'Enter' && (event.shiftKey || event.metaKey) && editor.canInsertLineBreak()) {
        event.preventDefault();
        return editor.insertLineBreak();
      }

      return next();
    }
  }, renderInlines(_defineProperty({}, EntityTypes.LINE_BREAK, function (_ref3) {
    var attributes = _ref3.attributes;
    return React.createElement("br", attributes);
  }))];
});